
export const DEBOUNCE_TIME = 700;
export const PAGE = 0;
export const PAGE_SIZE = 10;
